import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6 col-xxl-6 col-sm-6 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations générales", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)
const _hoisted_9 = { class: "table" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Nom", -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Slug", -1)
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Slot", -1)
const _hoisted_16 = { key: 3 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Numéro série", -1)
const _hoisted_18 = { key: 4 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Description", -1)
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { key: 5 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "prixAchat", -1)
const _hoisted_23 = { key: 6 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Prix de vente", -1)
const _hoisted_25 = { key: 7 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Prix promo", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Est en promo", -1)
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 8 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Quantité", -1)
const _hoisted_32 = { key: 9 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Quantité rupture", -1)
const _hoisted_34 = { key: 10 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Seuil alerte", -1)
const _hoisted_36 = { key: 11 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Garantie", -1)
const _hoisted_38 = { key: 12 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Date d'ajout", -1)
const _hoisted_40 = { class: "col-md-6 col-xxl-6 col-sm-6 mb-10" }
const _hoisted_41 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_42 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Autres informations")
], -1)
const _hoisted_44 = { class: "table" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Marchand:", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Catégorie:", -1)
const _hoisted_48 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_49 = { class: "col-12" }
const _hoisted_50 = { class: "col-6" }
const _hoisted_51 = { class: "badge badge-outline-danger text-outline-primary" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete icon-position" }, null, -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Collection:", -1)
const _hoisted_56 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_57 = { class: "col-12" }
const _hoisted_58 = { class: "col-6" }
const _hoisted_59 = { class: "badge badge-outline-danger text-outline-primary" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete icon-position" }, null, -1)
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = { key: 1 }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Model:", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Marque:", -1)
const _hoisted_66 = { class: "col-12" }
const _hoisted_67 = { class: "col-6" }
const _hoisted_68 = { class: "badge badge-outline-danger text-outline-primary" }
const _hoisted_69 = { key: 2 }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Couleur:", -1)
const _hoisted_71 = { key: 3 }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Poids:", -1)
const _hoisted_73 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_74 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_75 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_76 = { class: "table" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Nom"),
    /*#__PURE__*/_createElementVNode("th", null, "Mail"),
    /*#__PURE__*/_createElementVNode("th", null, "Contenu")
  ])
], -1)
const _hoisted_78 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_79 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_80 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_81 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_82 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_83 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_84 = { class: "table" }
const _hoisted_85 = { class: "row" }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = ["src"]
const _hoisted_88 = { class: "blog-card style1" }
const _hoisted_89 = ["href"]
const _hoisted_90 = { class: "blog-img" }
const _hoisted_91 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_router_link, {
              to: "/liste-produits",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8,
                _createTextVNode("Retour")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("tbody", null, [
              (_ctx.produit?.title)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit?.title), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.produit?.slug)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit?.slug), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.produit?.slot)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit?.slot), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.produit?.numeroSerie)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit?.numeroSerie), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.produit?.description)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("td", null, [
                      _createElementVNode("p", {
                        innerHTML: _ctx.produit?.description
                      }, null, 8, _hoisted_20)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.produit?.prixAchat)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit?.prixAchat), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.produit?.prixVente)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit.prixVente), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.produit?.prixPromo)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit.prixPromo), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _hoisted_27,
                (_ctx.produit?.is_sale)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_28, "Oui"))
                  : _createCommentVNode("", true),
                (!_ctx.produit?.is_sale)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_29, "Non"))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.produit?.depot)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit?.depot), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.produit?.quantiteRupture)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit?.quantiteRupture), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.produit?.seuilAlerte)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit?.seuilAlerte), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.produit?.garantie)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit?.garantie), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.produit?.dateAjout)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit?.dateAjout), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("table", _hoisted_44, [
            _createElementVNode("tbody", null, [
              (_ctx.produit?.marchand)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit?.marchand?.nom) + " " + _toDisplayString(_ctx.produit?.marchand.prenom) + " " + _toDisplayString(_ctx.produit?.marchand.raisonSocial), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _hoisted_47,
                _createElementVNode("td", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produit?.categories, (categorie) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: categorie.id,
                        class: "badge-container"
                      }, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("span", _hoisted_51, [
                            _createTextVNode(_toDisplayString(categorie.name) + " ", 1),
                            _createElementVNode("a", {
                              href: "javascript:void(0);",
                              class: "tag-delete-link text-outline-danger",
                              onClick: ($event: any) => (_ctx.suppCat(categorie.id,_ctx.produit?.id))
                            }, _hoisted_54, 8, _hoisted_52)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_55,
                _createElementVNode("td", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produit?.collections, (collection) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: collection.id,
                        class: "badge-container"
                      }, [
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("span", _hoisted_59, [
                            _createTextVNode(_toDisplayString(collection.name) + " ", 1),
                            _createElementVNode("a", {
                              href: "javascript:void(0);",
                              class: "tag-delete-link text-outline-danger",
                              onClick: ($event: any) => (_ctx.suppColl(collection.id,_ctx.produit?.id))
                            }, _hoisted_62, 8, _hoisted_60)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              (_ctx.produit?.model)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_63, [
                    _hoisted_64,
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit?.model?.nom), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _hoisted_65,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_66, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produit?.brands, (brand) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: brand.id,
                        class: "badge-container"
                      }, [
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("span", _hoisted_68, _toDisplayString(brand.name), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              (_ctx.produit?.couleur)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_69, [
                    _hoisted_70,
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit?.couleur?.nom), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.produit?.poids)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_71, [
                    _hoisted_72,
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit?.poids), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_73, [
      _createElementVNode("div", _hoisted_74, [
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("table", _hoisted_76, [
            _hoisted_77,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produit?.avis, (avis) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: avis.id
                }, [
                  _createElementVNode("td", _hoisted_78, _toDisplayString(avis.nom), 1),
                  _createElementVNode("td", _hoisted_79, _toDisplayString(avis.email), 1),
                  _createElementVNode("td", _hoisted_80, _toDisplayString(avis.contenu), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_81, [
      _createElementVNode("div", _hoisted_82, [
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("table", _hoisted_84, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_85, [
                    (_ctx.produit?.urlImage)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_86, [
                          _createElementVNode("td", null, [
                            _createElementVNode("img", {
                              src: _ctx.getUrlApiForProductFiles(_ctx.produit.urlImage),
                              alt: "Image"
                            }, null, 8, _hoisted_87)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produits, (produit, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-xl-4 col-lg-6 col-md-6",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_88, [
                          _createElementVNode("a", {
                            href: _ctx.getUrlApiForProductFiles(produit.description),
                            target: "_blank",
                            "data-lightbox": "gallery"
                          }, [
                            _createElementVNode("div", _hoisted_90, [
                              _createElementVNode("img", {
                                src: _ctx.getUrlApiForProductFiles(produit.description),
                                alt: "Image"
                              }, null, 8, _hoisted_91)
                            ])
                          ], 8, _hoisted_89)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}